import { RankingTeam } from "@twire/redux/teamRanking/types";

export const sortAndTrim = (
  data: RankingTeam[],
  count: number
): RankingTeam[] => {
  // const sort = data.sort((a, b) => (a.ranking > b.ranking ? 1 : -1));
  return data.slice(0, count);
};
